import { CategoryService } from '@modules/category/category-service';
import Errors from '@shared/error/errors';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';

export default {
  namespaced: true,

  state: {
    loading: false,
  },

  getters: {
    loading: (state) => !!state.loading,
  },

  mutations: {
    DESTROY_ALL_STARTED(state) {
      state.loading = true;
    },

    DESTROY_ALL_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ALL_ERROR(state) {
      state.loading = false;
    },

    DESTROY_STARTED(state) {
      state.loading = true;
    },

    DESTROY_SUCCESS(state) {
      state.loading = false;
    },

    DESTROY_ERROR(state) {
      state.loading = false;
    },
  },

  actions: {
    async doDestroy({ commit, dispatch, rootGetters }, {id, manage}) {
      try {
        commit('DESTROY_STARTED');
        const manageInput = new ManageModel(manage ).getManageModel()

        await CategoryService.destroyAll([id], manageInput);
        
        dispatch('subproperty/requirements/doFetch', {
          propertyId: manage.property.id,
          subpropertyId: manage.subproperty.id,
          userId: rootGetters['auth/currentUser'].id
        }, {
          root: true
        });
        commit('DESTROY_SUCCESS');
        Message.success(i18n('entities.category.destroy.success'));
        dispatch('category/list/doFetch',{manage}, {root:true});
      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ERROR');
      }
    },

    async doDestroyAll(
      { commit, dispatch },
      {ids, manage},
    ) {
      try {
        commit('DESTROY_ALL_STARTED');

        const manageInput = new ManageModel(manage ).getManageModel()
        await CategoryService.destroyAll(ids, manageInput);

        commit('DESTROY_ALL_SUCCESS');

        dispatch(`${'category/list'}/doUnselectAll`, null, {
          root: true,
        });

        Message.success(
          i18n('entities.category.destroyAll.success'),
        );

      } catch (error) {
        Errors.handle(error);
        commit('DESTROY_ALL_ERROR');
      }
    },
  },
};
